import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PutNotificationPreferencesVariables = Types.Exact<{
  input: Types.PutNotificationPreferencesInput;
}>;

export type PutNotificationPreferences = {
  putNotificationPreferences: {
    preferences: Array<
      Pick<Types.NotificationPreference, 'topic'> & {
        channels: Array<Pick<Types.NotificationChannel, 'name' | 'enabled'>>;
      }
    >;
  };
};

export const PutNotificationPreferencesDocument = gql`
  mutation PutNotificationPreferences($input: PutNotificationPreferencesInput!) {
    putNotificationPreferences(input: $input) {
      preferences {
        topic
        channels {
          name
          enabled
        }
      }
    }
  }
`;
export type PutNotificationPreferencesMutationFn = Apollo.MutationFunction<
  PutNotificationPreferences,
  PutNotificationPreferencesVariables
>;

/**
 * __usePutNotificationPreferences__
 *
 * To run a mutation, you first call `usePutNotificationPreferences` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutNotificationPreferences` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putNotificationPreferences, { data, loading, error }] = usePutNotificationPreferences({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePutNotificationPreferences(
  baseOptions?: Apollo.MutationHookOptions<
    PutNotificationPreferences,
    PutNotificationPreferencesVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PutNotificationPreferences, PutNotificationPreferencesVariables>(
    PutNotificationPreferencesDocument,
    options,
  );
}
export type PutNotificationPreferencesHookResult = ReturnType<typeof usePutNotificationPreferences>;
export type PutNotificationPreferencesMutationResult =
  Apollo.MutationResult<PutNotificationPreferences>;
export type PutNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<
  PutNotificationPreferences,
  PutNotificationPreferencesVariables
>;
export function mockPutNotificationPreferences({
  data,
  variables,
  errors,
}: {
  data: PutNotificationPreferences;
  variables?: PutNotificationPreferencesVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: PutNotificationPreferencesDocument, variables },
    result: { data, errors },
  };
}
